import { tryFetch, HttpMethod, type HttpResponse } from '@/services/http'
import type { ProfileRequest } from './user.requests'
import type { ActivationErrorCode, RegisterErrorCode, UserErrorCode } from '../types/user.enums'
import type { Profile, User, Identity, UserSetting, RegisterUser } from '../models/user.model'

const BASE_URL = import.meta.env.VITE_MAIN_BASE_URL

const getUserIdentity = async (): Promise<HttpResponse<Identity | null, UserErrorCode>> =>
  await tryFetch<Identity | null, UserErrorCode>(HttpMethod.Get, BASE_URL, 'user/identity')

const getUser = async (): Promise<HttpResponse<User | null, UserErrorCode>> =>
  await tryFetch<User | null, UserErrorCode>(HttpMethod.Get, BASE_URL, 'user/me')

const updateUserProfile = async (
  body: ProfileRequest,
): Promise<HttpResponse<Profile | null, UserErrorCode>> =>
  await tryFetch<Profile | null, UserErrorCode>(HttpMethod.Patch, BASE_URL, 'user/profile', {
    body,
  })

const updateUserSetting = async (
  body: UserSetting,
): Promise<HttpResponse<UserSetting | null, UserErrorCode>> =>
  await tryFetch<UserSetting | null, UserErrorCode>(HttpMethod.Patch, BASE_URL, 'user/setting', {
    body,
  })

const activateUser = async (code: string): Promise<HttpResponse<null, ActivationErrorCode>> =>
  await tryFetch<null, ActivationErrorCode>(HttpMethod.Post, BASE_URL, 'user/activate', {
    body: code,
  })

const registerUser = async (body: RegisterUser): Promise<HttpResponse<null, RegisterErrorCode>> =>
  await tryFetch<null, RegisterErrorCode>(HttpMethod.Post, BASE_URL, 'user/register', {
    body,
  })

export const userApi = {
  getUserIdentity,
  getUser,
  updateUserProfile,
  updateUserSetting,
  activateUser,
  registerUser,
}
